/*
Laminate

--manufacturer <Manufacturer>
--manufacturerNumber <string>
--computerEaseNumber <string>
*/
import {
  certification,
  color,
  length,
  manufacturer,
  type,
  width
} from '@/modules/standardItems/schemas/baseFilters'

export default [
  type(),
  color(),
  certification(),
  {
    label: 'Thickness',
    value: 'thickness',
    type: 'list',
    returnObject: false
  },
  length(),
  width(),
  manufacturer()
]
